<template>
  <div 
    style="padding-top: 48px; padding-left: 120px;"
    class="step general">
    <div class="general-title">
      <h5>ADD STATUS CONTENT</h5>
    </div>
    <div class="general-tags">
      <span
        v-for="(item, index) in tags"
        :key="index"
        class="general-tag"
        @click.prevent="deleteTag(index)">{{ item.tag }}</span>
      <span
        v-show="!show.showInput"
        :class="{'tag-error': errors.tagError}"
        class="tag-add"
        @click="addTag">Click to add tags <span 
          v-if="errors.tagError" 
          class="tag-error"> - required</span></span>
      <input
        v-show="show.showInput"
        v-model="input.inputText"
        type="text"
        class="general-input"
        @keyup.enter="saveTag">
    </div>
    <div class="general-actions">

      <div class="general-date">
        <p>Created: {{ transformDateCustom(currentDate, 'DD MMM') }}</p>
        <p>Updated: {{ transformDateCustom(currentDate, 'DD MMM') }}</p>
      </div>
      <div class="general-action">
        <div class="delete-action">
          <img :src="getImageUrl('/images/trash.svg')">
        </div>
        <div class="button-action">
          <span @click="saveCurl">save</span>
        </div>
      </div>
    </div>
    <hr>
    <div class="general-body">
      <div class="body-title">
        <h4
          v-show="!show.showTitle"
          @click="addTitle"
        >{{ title }}</h4>
        <input
          v-show="show.showTitle"
          v-model="title"
          type="text"
          class="title-input"
          placeholder="Your title"
          @keyup.enter="saveTitle">
      </div>
      <div class="body-content">
        <p
          v-show="!show.showTextArea"
          style="cursor: pointer;"
          @click="addTextarea">
          {{ content }}
        </p>
        <textarea
          v-show="show.showTextArea"
          v-model="content"
          style="resize: none; width: 92%; height: 240px;"
          placeholder="Your content"
          @blur="onBlur"
        />
      </div>
    </div>
  </div>
</template>

<script>
import profileMixin from "@/mixins/profileMixin";
import moment from "moment";
import {mapGetters} from "vuex";

export default {
  name: "General",
  mixins: [profileMixin],

  data() {
    return {
      title: '',
      content: '',
      tags: [],
      currentDate: '',
      show: {
        showInput: false,
        showTextArea: false,
        showTitle: false,
      },
      input: {
        inputText: '',
      },
      textArea: {
        textAreaText: '',
      },
      errors: {
        tagError: false
      }
    }
  },

  computed: {
    ...mapGetters(['curl']),
  },
  mounted() {
    this.currentDate = moment().format();
    if (this.content === '') {
      this.show.showTextArea = true;
    }

    if (this.title === '') {
      this.show.showTitle = true;
    }
  },
  methods: {
    addTag() {
      this.show.showInput = true;
    },
    saveTag() {
      this.show.showInput = false;
      this.tags.push({tag: this.input.inputText});
      this.input.inputText = '';
    },
    deleteTag(index) {
      this.tags.splice(index, 1);
    },
    addTextarea() {
      this.show.showTextArea = true;
    },
    onBlur() {
      if (this.content !== '') {
        this.show.showTextArea = false;
      }
    },
    saveCurl() {
      if (this.tags.length) {
        const saveData = {
          tags: this.tags,
          title: this.title,
          content: this.content
        }
        this.$emit('curlData', saveData);
      } else {
        this.errors.tagError = true;
      }
    },
    addTitle() {
      this.show.showTitle = true;
    },
    saveTitle() {
      if (this.title !== '') {
        this.show.showTitle = false;
      }
    }
  }
}
</script>

<style scoped>
  .tag-error {
    color: red !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/modals/AddCurlStatus/steps/General.vue